import classNames from 'classnames';
import * as React from 'react';
import { PinProps } from './pin_low_activity';

export const PinLowActivitySelected = (props: PinProps) => {
  const { onClick, className } = props;

  const fill = '#061622';
  const icon = (
    <>
      <path
        d="M71.0187 88.3885C84.614 88.3885 95.6352 77.4115 95.6352 63.8706C95.6352 50.3298 84.614 39.3528 71.0187 39.3528C57.4235 39.3528 46.4023 50.3298 46.4023 63.8706C46.4023 77.4115 57.4235 88.3885 71.0187 88.3885Z"
        fill="white"
      />
      <path
        d="M79.4646 66.3566C78.6696 67.2232 78.1926 67.6171 77.0796 67.6171C75.9666 67.6171 75.5692 67.1444 74.6947 66.3566C73.8997 65.4899 72.8662 64.4658 71.0377 64.387C74.0587 59.5812 76.3641 56.1935 76.3641 53.3573C76.4436 50.4423 73.7407 48 70.7197 48C67.6988 48 64.9959 50.4423 64.9959 53.3573C64.9959 56.1935 67.3013 59.5812 70.3223 64.387C68.4938 64.4658 67.4603 65.4899 66.6653 66.3566C65.8703 67.2232 65.3934 67.6171 64.2804 67.6171C63.1674 67.6171 62.8494 67.2232 61.9749 66.3566C61.1799 65.4899 60.1465 64.4658 58.2385 64.387C58.159 64.387 58 64.5445 58 64.6233V66.4353C58 66.5929 58.0795 66.6717 58.2385 66.6717C59.113 66.7505 59.59 67.1444 60.3055 67.9322C61.1799 68.7988 62.2134 69.9018 64.2804 69.9018C66.3473 69.9018 67.4603 68.7988 68.2553 67.9322C69.0503 67.0656 69.5273 66.6717 70.6403 66.6717C71.7532 66.6717 72.1507 67.1444 73.0252 67.9322C73.8997 68.7988 74.9332 69.9018 77.0001 69.9018C79.0671 69.9018 80.1801 68.7988 81.0545 67.9322C81.77 67.1444 82.247 66.7505 83.1215 66.6717C83.2805 66.6717 83.36 66.5929 83.36 66.4353V64.6233C83.36 64.4658 83.201 64.387 83.1215 64.387C81.293 64.4658 80.2596 65.5687 79.4646 66.3566ZM70.7197 50.2847C72.5482 50.2847 74.1382 51.7028 74.1382 53.3573C74.1382 55.0905 72.7072 57.5328 70.7197 60.6841C68.7323 57.6116 67.3013 55.0905 67.3013 53.3573C67.3013 51.7816 68.9708 50.2847 70.7197 50.2847Z"
        fill={fill}
      />
      <path
        d="M79.3975 73.113C78.605 74.0187 78.1295 74.4304 77.02 74.4304C75.9105 74.4304 75.5142 73.9364 74.6425 73.113C73.7708 72.2073 72.7405 71.0546 70.68 71.0546C68.6195 71.0546 67.51 72.2073 66.7175 73.113C65.925 74.0187 65.4495 74.4304 64.34 74.4304C63.2305 74.4304 62.8342 73.9364 61.9625 73.113C61.17 72.2073 60.1398 71.1369 58.2377 71.0546C58.0792 71.0546 58 71.1369 58 71.3016V73.1953C58 73.36 58.0792 73.4424 58.2377 73.4424C59.1095 73.5247 59.585 73.9364 60.2983 74.7598C61.17 75.6655 62.2795 76.8182 64.34 76.8182C66.4005 76.8182 67.51 75.6655 68.3025 74.7598C69.095 73.854 69.5705 73.4424 70.68 73.4424C71.7895 73.4424 72.1858 73.9364 73.0575 74.7598C73.9293 75.6655 74.9595 76.8182 77.02 76.8182C79.0805 76.8182 80.19 75.6655 81.0618 74.7598C81.775 73.9364 82.2505 73.5247 83.1223 73.4424C83.2808 73.4424 83.36 73.36 83.36 73.1953V71.3016C83.36 71.1369 83.2015 71.0546 83.1223 71.0546C81.2203 71.1369 80.19 72.2073 79.3975 73.113Z"
        fill={fill}
      />
    </>
  );

  return (
    <div className={classNames('relative', className)} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="139"
        height="139"
        viewBox="0 0 139 139"
        fill="none"
      >
        <g filter="url(#filter0_d_379_19641)">
          <circle cx="69.5" cy="65.5" r="65.5" fill="#061622" fill-opacity="0.44" />
        </g>
        <g filter="url(#filter1_d_379_19641)">
          <circle cx="69.5" cy="64.5" r="48.5" fill="#061622" fill-opacity="0.69" />
          <path
            d="M108 63.8708C108 92.9318 79.124 102.093 71.7353 127.437C71.5091 128.225 70.4536 128.225 70.2274 127.437C61.934 99.8028 28.6095 89.9656 34.7542 55.6106C36.6767 44.7596 43.8769 35.373 53.9798 30.7924C81.3858 18.402 108 38.0388 108 63.8333V63.8708Z"
            fill={fill}
            stroke="#061622"
            stroke-opacity="0.16"
            stroke-width="2"
          />
          {icon}
        </g>
        <defs>
          <filter
            id="filter0_d_379_19641"
            x="0"
            y="0"
            width="139"
            height="139"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_379_19641" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_379_19641"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_379_19641"
            x="17"
            y="16"
            width="105"
            height="121.028"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_379_19641" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_379_19641"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

PinLowActivitySelected.width = 139;
PinLowActivitySelected.height = 139;
